import { render, staticRenderFns } from "./FinancialRulesDialog.vue?vue&type=template&id=a4963fc0&scoped=true&"
import script from "./FinancialRulesDialog.vue?vue&type=script&lang=js&"
export * from "./FinancialRulesDialog.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRulesDialog.vue?vue&type=style&index=0&id=a4963fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4963fc0",
  null
  
)

export default component.exports